export default __webpack_public_path__ + "static/2.5.4/media/diagmaticLogo.c8db828e.svg";